import { render, staticRenderFns } from "./OptionNotAvailable.vue?vue&type=template&id=82f75068"
import script from "./OptionNotAvailable.vue?vue&type=script&lang=js"
export * from "./OptionNotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports